import React from 'react';
import styleable from 'react-styleable';
import { injectIntl } from 'react-intl';
import styles from './index.scss';
import AddGroupForm from './form';
import AddGroupConfirmation from './confirmation';
import ExceedGroup from './max-group-error';
import withModal from '../with-modal';

const maxGroupThreshold = 12;

const AddGroup = (props) => {
    const { addGroupExceedGroupError, addGroupIsSuccess, classroomDetail } = props;
    const { classroomGroups } = classroomDetail;

    let content = !addGroupIsSuccess
        ? <AddGroupForm {...props} />
        : <AddGroupConfirmation {...props} />;

    if ((classroomGroups.length >= maxGroupThreshold && !addGroupIsSuccess) || addGroupExceedGroupError) {
        content = (<ExceedGroup {...props} />);
    }
    return (content);
};

const StyledAddGroup = injectIntl(styleable(styles)(AddGroup));
const AddGroupWithModal = withModal('isActive')(StyledAddGroup);

export default AddGroupWithModal;



// WEBPACK FOOTER //
// ./app/components/add-group/index.js